import { useQuery } from "react-query";
import { authInstance } from "apis";
import Location from "types/Location";

const useLocation = () => {
  const fetcher = async () => {
    const { data } = await authInstance.get("location");
    return data;
  };
  const { data: locations } = useQuery<Location[]>(["location"], fetcher);

  return locations;
};

export default useLocation;
